import { ETIQUETA, type Situacion } from '../utils/estadoTabla';

export function EstadoBadge({ situacion, titulo }: { situacion: Situacion; titulo?: string }) {
  return (
    <span className={`badge badge-${situacion}`} title={titulo}>
      {ETIQUETA[situacion]}
    </span>
  );
}
